import basename from './basename';

// Hôte du backend (les fichiers /uploads/ sont servis par l'API, pas par le frontend)
const API_ORIGIN = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/api$/, '');

/**
 * Préfixe les assets publics avec le chemin de base (ex. /tarjemlek/images/logo.png).
 * Les chemins /uploads/… sont servis par le backend.
 */
export default function assetUrl(path) {
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('//')) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (normalized.startsWith('/uploads/')) return `${API_ORIGIN}${normalized}`;
  return `${basename}${normalized}`;
}
